import { resolveUpdate } from './resolve';

export const createSessionSlice = (set) => ({
  session: null,
  setSession: (suivant) => set((etat) => ({ session: resolveUpdate(suivant, etat.session) })),
  profile: null,
  setProfile: (suivant) => set((etat) => ({ profile: resolveUpdate(suivant, etat.profile) })),
  authLoading: true,
  setAuthLoading: (suivant) =>
    set((etat) => ({ authLoading: resolveUpdate(suivant, etat.authLoading) })),
  loginError: '',
  setLoginError: (suivant) =>
    set((etat) => ({ loginError: resolveUpdate(suivant, etat.loginError) })),
  isRecovery: false,
  setIsRecovery: (suivant) =>
    set((etat) => ({ isRecovery: resolveUpdate(suivant, etat.isRecovery) })),
  recoveryType: 'recovery', // 'invite' | 'recovery'
  setRecoveryType: (suivant) =>
    set((etat) => ({ recoveryType: resolveUpdate(suivant, etat.recoveryType) })),
});
